import { render } from "./AddMagicUrl.vue?vue&type=template&id=a3424fa4"
import script from "./AddMagicUrl.vue?vue&type=script&lang=js"
export * from "./AddMagicUrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__